let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8lOO4")).then(() => parcelRequire('4IgPD'));